// LocationPicker.tsx
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

declare global {
  interface Window {
    google: any;
  }
}

const LocationPicker: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const initialCoords = location.state?.coords; // no default

  const [marker, setMarker] = useState<any>(null);
  const [map, setMap] = useState<any>(null);
  const [coords, setCoords] = useState(initialCoords || null);
  const [address, setAddress] = useState<string>("");





  useEffect(() => {
    if (!window.google || !initialCoords) return;

    const mapInstance = new window.google.maps.Map(
      document.getElementById("map") as HTMLElement,
      {
        center: initialCoords,
        zoom: 14,
      }
    );
    setMap(mapInstance);

    const markerInstance = new window.google.maps.Marker({
      position: initialCoords,
      map: mapInstance,
      draggable: true,
    });
    setMarker(markerInstance);

    // Update state when user drags marker
    window.google.maps.event.addListener(markerInstance, "dragend", (e: any) => {
      const newCoords = { lat: e.latLng.lat(), lon: e.latLng.lng() };
      setCoords(newCoords);
      getAddressFromCoords(newCoords);
    });

    // Get initial address
    getAddressFromCoords({ lat: initialCoords.lat, lon: initialCoords.lng });
  }, [initialCoords]);

const getAddressFromCoords = (coords: { lat: number; lon: number }) => {
  const geocoder = new window.google.maps.Geocoder();
  geocoder.geocode(
    { location: { lat: coords.lat, lng: coords.lon } }, 
    (results: any[], status: string) => {
      if (status === window.google.maps.GeocoderStatus.OK && results[0]) {
        setAddress(results[0].formatted_address);
      } else {
        setAddress("Address not found");
      }
    }
  );
};


  // const handleConfirm = () => {
  //   if (!coords || !address) return alert("Please select a location first.");

  //   // Save Lat/Lon

  //   localStorage.setItem("selectedLatLng", JSON.stringify([coords]));

  //   // Save Address / Locality
  //   localStorage.setItem("selectedLocality", JSON.stringify([address]));

  //   navigate(-1);
  // };

const handleConfirm = () => {
  if (!coords || !address) return alert("Please select a location first.");

  // Convert lng → lon if needed
  const formattedCoords = [{
    lat: coords.lat,
    lon: coords.lon ?? coords.lng, // fallback if coords.lon is undefined
  }];

  localStorage.setItem("selectedLatLng", JSON.stringify(formattedCoords));

  // Save Address / Locality
  localStorage.setItem("selectedLocality", JSON.stringify([address]));

  navigate(-1);
};



  if (!initialCoords) {
    return (
      <div style={{ textAlign: "center", marginTop: 100 }}>
        <p>Please provide coordinates to pick a location.</p>
      </div>
    );
  }

  return (
    <div style={{ height: "100vh", position: "relative" }}>
      {/* Map */}
      <div id="map" style={{ height: "100%", width: "100%" }}></div>

      {/* Address Display */}
      <div
        style={{
          position: "absolute",
          bottom: 70,
        //   left: "50%",
        //   transform: "translateX(-50%)",
          background: "white",
          padding: "10px 15px",
          borderRadius: 8,
          boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
          fontSize: 14,
          maxWidth: "90%",
          textAlign: "center",
          margin:"0 20px"
        }}
      >
        <strong></strong>
        <div>{address || "Loading..."}</div>
      </div>

      {/* Confirm Button */}
      <div
        style={{
          position: "absolute",
          bottom: 20,
          left: 0,
          right: 0,
          textAlign: "center",
        }}
      >
        <button
          onClick={handleConfirm}
          style={{
            backgroundColor: "var(--secondary-color)",
            color: "white",
            border: "none",
            borderRadius: 8,
            padding: "12px 20px",
            fontSize: 16,
            cursor: "pointer",
          }}
        >
          Confirm Location
        </button>
      </div>
    </div>
  );
};

export default LocationPicker;
